/** Where a horizontal tab row sits: centered, or at the inline start (left in LTR, right in RTL). */
export const TABS_LIST_ALIGNMENTS = ['center', 'start'] as const;

export type TabsListAlign = (typeof TABS_LIST_ALIGNMENTS)[number];

/** How unselected `button` look tabs are painted: gray outline, or neutral gray fill. */
export const TABS_UNSELECTED_STYLES = ['outline', 'filled'] as const;

export type TabsUnselectedStyle = (typeof TABS_UNSELECTED_STYLES)[number];

/** Space between the tab list and the panel. Omitted keeps the default spacing. */
export const TABS_GAPS = ['sm', 'lg'] as const;

export type TabsGap = (typeof TABS_GAPS)[number];

/** Public tab looks, in the order authors see them. */
export const TABS_LOOKS = ['underline', 'accent', 'button', 'track'] as const;

export type TabsLook = (typeof TABS_LOOKS)[number];

/** Palette families for the `track` look's selected pill and outline. `default` is black. */
export const TABS_TRACK_COLORS = Object.freeze([
  'default',
  'primary',
  'secondary',
  'tertiary',
  'accent',
] as const);

export type TabsTrackColor = (typeof TABS_TRACK_COLORS)[number];

/**
 * How tall the panel area is relative to its tabs and parent.
 * - `tallest` — as tall as the longest panel (today's default).
 * - `selected` — as tall as the open panel; closed panels stay mounted but do not add height.
 * - `fill` — the tabs stretch to fill their parent; the open panel fills the space under the tab list.
 */
export const TABS_PANEL_HEIGHTS = ['tallest', 'selected', 'fill'] as const;

export type TabsPanelHeight = (typeof TABS_PANEL_HEIGHTS)[number];
